class Dropdown {
    constructor(dropdownContainer) {
        this.dropdownContainer = dropdownContainer;
        this.dropdownItems = this.dropdownContainer.querySelectorAll('.dropdown-item');
        this.contentContainer = document.querySelector('#tab-content');
        this.currentRoomText = document.querySelector('#current-room');

        if (!this.dropdownItems.length) {
            console.log('No dropdown items were found');
            return;
        }

        /* Open the dropdown menu */
        this.dropdownContainer.addEventListener('click', event => {
            this.dropdownContainer.classList.toggle('is-active');
        })

        /* Determine the initial room */
        this.currentRoom = this.getInitialRoom();
        

        /* Dropdown menu controls */
        for (const item of this.dropdownItems) {
            /* Check that all dropdown items have corresponding content */
            if (!this.contentContainer.querySelector(`.${item.dataset.target}`)) {
                console.warn(`Dropdown item ${item.dataset.target} does not have corresponding content`);
            }

            /* Add event listener to each dropdown item */
            item.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();

                const selectedRoom = event.target.dataset.target;
                /* Switch to the selected room */
                this.switchToRoom(selectedRoom);
                /* Close the dropdown menu */
                this.dropdownContainer.classList.remove('is-active');
            });
        }

        /* Initial activation of the current room */
        this.switchToRoom(this.currentRoom);

        /* Close the dropdown menu when clicking outside of it */
        document.addEventListener('click', event => {
            if (!this.dropdownContainer.contains(event.target)) {
                this.dropdownContainer.classList.remove('is-active');
            }
        });

        /* Close the dropdown menu when pressing the escape key */
        document.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                this.dropdownContainer.classList.remove('is-active');
            }
        });

        /* Close the dropdown menu when scrolling */
        window.addEventListener('scroll', () => {
            this.dropdownContainer.classList.remove('is-active');
        });
        
    }

    /* Function to get the initial room */
    getInitialRoom() {
        /* Get the query parameter */
        const urlParameters = new URLSearchParams(window.location.search);
        const targetRoom = urlParameters.get('room');

        /* Check if the dropdown item with the value from the query parameter exists */
        const specificRoom = [...this.dropdownItems].find(item => item.dataset.target === targetRoom);

        /* Return the specific room if it exists, otherwise return the first dropdown item's data-target */
        return specificRoom ? specificRoom.dataset.target : this.dropdownItems[0].dataset.target;
    }

    /* Show content by room ID */
    showContent(roomId) {
        /* Deactivate all other room contents */
        for (const item of this.dropdownItems) {
            const roomContents = this.contentContainer.querySelectorAll(`.${item.dataset.target}`);
            roomContents.forEach(content => {
                content.classList.add('is-hidden');
            });
        }

        /* Activate all divs matching the current roomId */
        const activeContents = this.contentContainer.querySelectorAll(`.${roomId}`);
        activeContents.forEach(content => {
            content.classList.remove('is-hidden');
        });
    }

    /* Switch to room by ID */
    switchToRoom(roomId) {
        this.currentRoom = roomId;

        /* Update the text of the current room (located underneath the dropdown menu) */
        this.currentRoomText.textContent = this.dropdownContainer.querySelector(`[data-target="${roomId}"]`).textContent;

        /* Deactivate all other dropdown items */
        for (const item of this.dropdownItems) {
            item.classList.remove('is-active');
        }

        /* Activate the selected dropdown item */
        const selectedDropDownitem = this.dropdownContainer.querySelector(`[data-target="${roomId}"]`);
        selectedDropDownitem?.classList.add('is-active');

        /* Show corresponding content */
        this.showContent(roomId);

        // /* Update the URL to remove the ?room=... parameter */
        const url = new URL(window.location);

        if (url.searchParams.has('room')) {
            url.searchParams.delete('room');
            history.replaceState({}, '', url);
        }
    }
}

export default Dropdown;
